import { DcSccBaseValidators } from 'dc-scc';

export abstract class BaseObject extends DcSccBaseValidators
{
	
}